export default {
	status: {
		400: "Request failed! Please try again later",
		401: "Login session expired! Please log in again",
		403: "Current account does not have access permission",
		404: "The resource you are trying to access does not exist",
		405: "Incorrect request method! Please try again later",
		408: "Request timed out! Please try again later",
		500: "Service encountered an exception",
		990: "Your account has been frozen due to uncompleted tasks for a long time",
		10030008: "Please return the assistance fund before applying for cash withdrawal",
		10030010: "Invitation code does not exist",
		10030011: "Exceeded the maximum number of check-in times",
		10030012: "Do not meet the check-in conditions, please complete the task first",
		10030013: "Sign-in configuration error, please contact customer service",
		10030014: "Not within the allowed time period",
		10030015: "Member does not exist",
		// 10030016: "User has filled in {0} pieces of data, please contact Customer Service to apply for resetting account.",
		10030016:
			"Dear User: Congratulations! You have successfully completed 100% of your product promotion. Please contact platform support to request a reset.",
		10030017: "Unable to match product, please contact customer service",
		10030018: "Insufficient account balance",
		10030019: "Account has been disabled",
		10030020: "Account prohibited from trading",
		10030021: "Account withdrawal prohibited",
		10030022: "Transaction password error",
		10030023: "The withdrawal account is not bound, please bind the withdrawal account first",
		10030024: "Old password error",
		10030027: "Your withdrawal is restricted. Please contact customer service for more details",
		10030028: "Low credit scores prevent you from pulling money",
		10030030: "Not within the allowed time period",
		10030031: "Please contact customer service to reset today's task",
		10030050: "The order has expired. Please contact customer service for assistance."
	},
	errorHandler: {
		InternalError: "Internal error in the JavaScript engine",
		ReferenceError: "Object not found",
		TypeError: "Incorrect type or object used",
		RangeError: "Parameter out of range when using built-in objects",
		SyntaxError: "Syntax error",
		EvalError: "Incorrect use of Eval",
		URIError: "URI error",
		UnknownError: "Unknown"
	},
	Network: {
		timedout: "Request timed out! Please try again later",
		error: "Network error! Please try again later"
	},
	request: {
		NoMoreData: "No more data",
		OnlyImage: "Please upload image files only.",
		FileMaxSize: "The file size exceeds the maximum value, which is {0}M"
	},
	response: {
		loading: "Loading",
		success: "Success",
		fail: "Fail",
		complete: "Complete"
	},
	page: {
		noVerify: "Wallet not verified. Please verify your wallet first.",
		notexist: "Sorry, the page you are trying to access does not exist~"
	}
};
